// We morph the page in place instead of replacing the body,
// so a `<dialog>` that is open when a visit starts is still
// open after the render, sitting over a page it has nothing
// to do with. Closing every open one first is what stops a
// modal surviving a navigation.
//
// The selector is `dialog[open]`, NOT `dialog:open`.
// `:open` is a Selectors 4 pseudo-class that Safari only
// learned in 17.4, and `querySelectorAll` does not skip a
// selector it cannot parse: it throws `SyntaxError`, which
// aborts the listener before it closes anything. So on the
// browsers this mattered most on (Mobile Safari, and every
// in-app webview riding on it) no dialog has ever been
// closed here, and the throw itself was 81k Sentry events
// (CALISTO-B1, CAL-504).
//
// The two are equivalent wherever both parse: `show()` and
// `showModal()` each set the `open` attribute, and `:open`
// on a dialog is defined as carrying that attribute.
//
// Takes the root as an argument rather than reading the
// global, so it can be exercised without booting the whole
// entrypoint.
export default function closeOpenDialogs(root = document) {
  root.querySelectorAll("dialog[open]").forEach((dialog) => {
    dialog.close();
  });
}
